import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import { ActionSelectorButton } from "@circle-react-uikit/ActionSelectorButton";
import { useBroadcastData } from "../BroadcastDataContext";
import { useUpsertTemplateModal } from "../UpsertTemplateModal/useUpsertTemplateModal";

const localeNamespace = "settings.emails.builder";

const CHANGE_TEMPLATE_OPTION = {
  label: t([localeNamespace, "change_template"]),
  value: "CHANGE_TEMPLATE",
};

export function SubmitActionButton({
  disabled = false,
  closeEditor,
  saveEditorContent,
}: {
  disabled?: boolean;
  closeEditor: () => void;
  saveEditorContent: () => void;
}) {
  const { data } = useBroadcastData();
  const {
    openModal: openUpsertTemplateModal,
    modalElement: upsertTemplateModalElement,
  } = useUpsertTemplateModal();

  const upsertMode = () => {
    if (data?.marketing_email_template_id !== null) {
      return "upsert";
    }
    return "create_only";
  };

  const options = [
    {
      label: disabled ? t("saving") : t([localeNamespace, "save_and_exit"]),
      value: "SAVE_AND_EXIT",
      onClick: () => {
        saveEditorContent();
        closeEditor();
      },
    },
    {
      label: t([localeNamespace, "save_template"]),
      value: "SAVE_TEMPLATE",
      onClick: () => {
        saveEditorContent();
        openUpsertTemplateModal(upsertMode());
      },
    },
    CHANGE_TEMPLATE_OPTION,
  ];

  return (
    <>
      <ActionSelectorButton
        options={options}
        setSelectedAction={noop}
        disabled={disabled}
        type="button"
        variant="circle"
      />
      {upsertTemplateModalElement}
    </>
  );
}
